module.exports = __webpack_public_path__ + "img/confirm-visit.32b6f91.png";